<template>
    <div class="modal" ref="addActivityModal" id="addActivityModal" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">

                <div class="modal-header bg-white font-bold">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Select Activity</h5>
                    <button type="button" class="close text-black" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-grey-darkest">
                    <div class="pt-4 pb-2 px-3">
                        <div v-if="form.sales_behaviors.length > 0" v-for="(item,index) in form.sales_behaviors"
                             class="flex mb-2 inline-block">
                            <div class="col-1 px-1 flex items-center" v-if="atLeastOneHasDate">
                                <input v-if="item.date && !item.follow_up" type="checkbox" id="" name="" true-value="1"
                                       false-value="0" class="sales-behavior-checkbox"
                                       v-model="item.completed">
                            </div>
                            <label class="text-grey-darkest fs-3 col-6 px-1 mb-0 flex items-center" :class="{'text-red' : form.errors.has(item.name)}">{{
                                    item.name
                                }}:</label>
                            <div v-show="calendarAccess===0" class="flex px-1"
                                 :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                <datetime type="date" name="date"
                                          v-model="item.date" use12-hour
                                          :ref=item.name
                                          class="w-full"
                                          :week-start="7"
                                          :format="masks.date_mask"
                                          :use-utc="true"
                                          :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                          @input="form.errors.clear('start_date'); resetValidationErrors(item.name);">
                                </datetime>

                                <button v-if="item.date" @click.prevent.stop="removeDateTimePicker(index)"
                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/6">clear
                                </button>

                            </div>
                            <div v-show="calendarAccess" class="flex px-1"
                                 :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                <datetime type="datetime" name="date"
                                          v-model="item.date" use12-hour
                                          :ref=item.name
                                          class="w-full"
                                          :week-start="7"
                                          :format="masks.date_time_mask"
                                          :use-utc="true"
                                          :minute-step="15"
                                          :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                          @input="form.errors.clear('start_date'); resetValidationErrors(item.name);">
                                </datetime>
                                <button v-if="item.date" @click.prevent.stop="removeDateTimePicker(index)"
                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/6">
                                    clear
                                </button>
                            </div>
                        </div>
                        <div v-if="form.sales_behaviors.length === 0" class="mmb-2b-2">
                            <div class="text-grey-darkest text-sm">
                                Your company does not currently have any sales behaviors.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary assign-user-btn" @click.prevent="massUpdate()">
                        Assign <i v-if="loadingUpdate" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";

export default {
    name: 'add-activity',
    props: {
        checked_project_ids: { type: Array },
        calendar: {},
        masks: {},
    },
    components: { Multiselect },

    data() {
        return {
            loadingUpdate: false,
            calendarAccess: 0,
            form: new Form({
                project_ids: [],
                sales_behaviors: []
            })
        }
    },

    computed: {
        atLeastOneHasDate() {
            return _.some(this.form.sales_behaviors, (item) => item.date);
        }
    },

    created() {
        this.calendarAccess = this.calendar;
    },

    mounted() {
        $("#addActivityModal").on('hidden.bs.modal', () => this.clear());
    },

    methods: {
        open() {
            $(this.$el).modal('show');
            this.form.project_ids = [ ...this.checked_project_ids ];
            this.fetchSalesBehaviors();
        },

        fetchSalesBehaviors() {
            let self = this;
            axios.get(route('project.sales-behaviors')).then(({data}) => {
                self.form.sales_behaviors = data.data;
            });
        },

        removeDateTimePicker(index) {
            this.form.sales_behaviors[index].date = null;
        },

        resetValidationErrors(field) {
            if(field && this.form.errors.errors[field]) {
                delete this.form.errors.errors[field];
            }
        },

        close() {
            $(this.$el).modal('hide');
            this.clear();
        },

        clear() {
            this.form.project_ids     = [];
            this.form.sales_behaviors = [];
        },

        massUpdate()
        {
            this.loadingUpdate = true;
            let titleString = this.form.project_ids.length == 1 ? this.form.project_ids.length+' project is selected, are you sure you want to update it?' : this.form.project_ids.length+' projects are selected, are you sure you want to update them?';
            let textString = this.form.project_ids.length == 1 ? 'Record' : 'Records';
            Swal.fire({
                title: titleString,
                text: textString+" can't be undo once updated.",
                icon: "warning",
                buttons: true,
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    this.form.post('/api/project/mass-update/add-activity')
                        .then((data) => {
                            this.loadingUpdate = false;
                            this.close();
                            this.$emit('update-finished', data);
                        })
                        .catch((err) => {
                            this.loadingUpdate = false;
                            console.error(err);
                        });
                }
            });
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .assign-user-btn {
        border-radius: 25px !important;
    }
</style>
